const initDebug = () => {
  const toDebug = window.location.href.includes('edktDebug=true');
  const func = (...data: any[]) => {
    if (toDebug) {
      console.debug('Edgekit', ...data);
    }
  };
  func.isActive = toDebug;
  return func;
};

export const debug = initDebug();
